function isValidCategory(v) {
    return v !== undefined && v !== null && v !== '' && v !== 'N/A';
}

function isValidValue(v) {
    return typeof v === 'number' && !Number.isNaN(v);
}

export function buildHeatmapSeries(points) {
    const xCategories = [];
    const yCategories = [];
    const xIndex = new Map();
    const yIndex = new Map();
    const data = [];

    (points || []).forEach(({ x, y, value }) => {
        if (!isValidCategory(x) || !isValidCategory(y) || !isValidValue(value)) {
            return;
        }
        if (!xIndex.has(x)) {
            xIndex.set(x, xCategories.length);
            xCategories.push(x);
        }
        if (!yIndex.has(y)) {
            yIndex.set(y, yCategories.length);
            yCategories.push(y);
        }
        data.push([xIndex.get(x), yIndex.get(y), value]);
    });

    return { xCategories, yCategories, data };
}
